import api from "./api";

export interface CampaignVisit {
  appVersion?: string;
  platform?: string;
  timestamp?: { _seconds?: number } | string | number;
}

export interface RawCampaign {
  name?: string;
  deeplinkUrl?: string;
  publisher?: string;
  createdAt?: unknown;
  visits?: CampaignVisit[];
}

type CampaignsResponse = RawCampaign[] | { campaigns?: RawCampaign[] };

/** Promo campaigns for a publisher. Gateway scopes non-superadmin to own house. */
export async function getCampaigns(publisher: string): Promise<RawCampaign[]> {
  const data = await api.get<unknown, CampaignsResponse>("/campaignsByPublisher", {
    params: { publisher },
  });
  if (Array.isArray(data)) return data;
  return data?.campaigns ?? [];
}

/** Create a book deep-link campaign. The campaign doc id is the book id. */
export async function createCampaign(input: {
  id: string;
  name: string;
  deeplinkUrl: string;
  publisher: string;
}): Promise<void> {
  await api.post("/createCampaign", input);
}
